(() => {
  if (typeof subscribe !== 'function') return;
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data } = {}) => {
    if (!data?.html || !data.sectionId) return;
    const values = new Map();
    data.html.querySelectorAll('[data-ps-commercial-section]').forEach((source) => {
      if (source.dataset.psCommercialSection !== String(data.sectionId)) return;
      source.querySelectorAll('[data-ps-value]').forEach((node) => {
        values.set(node.dataset.psValue, node.textContent);
      });
    });
    document.querySelectorAll('[data-ps-commercial-section]').forEach((root) => {
      if (root.dataset.psCommercialSection !== String(data.sectionId)) return;
      root.querySelectorAll('[data-ps-value]').forEach((node) => {
        if (values.has(node.dataset.psValue)) node.textContent = values.get(node.dataset.psValue);
      });
    });
  });
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-ps-cashback-close]');
    if (button) button.closest('modal-dialog')?.hide();
  });
})();

(() => {
  const labelGalleryNavigation = () => {
    document.querySelectorAll('gallery-section [data-gallery]').forEach((gallery) => {
      gallery.querySelector('.swiper-button-prev')?.setAttribute('aria-label', 'Imagem anterior');
      gallery.querySelector('.swiper-button-next')?.setAttribute('aria-label', 'Próxima imagem');
    });
  };
  labelGalleryNavigation();
  document.addEventListener('gallery:updated', labelGalleryNavigation);
  document.addEventListener('shopify:section:load', labelGalleryNavigation);

  let refreshController;
  const syncShipping = async ({ cartData } = {}) => {
    const target = document.querySelector('[data-ps-cart-shipping]');
    if (!target) return;
    refreshController?.abort();
    const sectionHtml = cartData?.sections?.['cart-drawer'];
    const source = sectionHtml ? new DOMParser().parseFromString(sectionHtml, 'text/html') : document.querySelector('cart-drawer');
    const bar = source?.querySelector('.wt-free-shipping-bar');
    if (bar) {
      target.replaceChildren(bar.cloneNode(true));
      target.hidden = false;
      return;
    }
    target.hidden = true;
    refreshController = new AbortController();
    try {
      const url = new URL(window.location.href);
      url.searchParams.set('section_id', target.dataset.psCartShipping);
      const response = await fetch(url, { signal: refreshController.signal });
      if (!response.ok) return;
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const updated = html.querySelector('[data-ps-cart-shipping] .wt-free-shipping-bar');
      if (updated && target.isConnected) {
        target.replaceChildren(updated);
        target.hidden = false;
      }
    } catch (error) {
      if (error.name !== 'AbortError') target.hidden = true;
    }
  };
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, syncShipping);
    subscribe('cart-drawer-close', () => syncShipping());
  }
})();
(() => {
  const requests = new WeakMap();
  const provinceCache = new Map();
  const provinces = new Set('Acre|Alagoas|Amapá|Amazonas|Bahia|Ceará|Distrito Federal|Espírito Santo|Goiás|Maranhão|Mato Grosso|Mato Grosso do Sul|Minas Gerais|Paraná|Paraíba|Pará|Pernambuco|Piauí|Rio Grande do Norte|Rio Grande do Sul|Rio de Janeiro|Rondônia|Roraima|Santa Catarina|Sergipe|São Paulo|Tocantins'.split('|'));
  const provinceFor = async (zip, signal) => {
    if (provinceCache.has(zip)) return provinceCache.get(zip);
    let response;
    try {
      response = await fetch(`https://viacep.com.br/ws/${zip}/json/`, {
        signal, credentials: 'omit', referrerPolicy: 'no-referrer', headers: { Accept: 'application/json' }
      });
    } catch (error) {
      if (error.name === 'AbortError') throw error;
      throw new Error('Não foi possível consultar seu CEP. Tente novamente.');
    }
    if (!response.ok) throw new Error('Não foi possível consultar seu CEP. Tente novamente.');
    const address = await response.json();
    if (address.erro) throw new Error('CEP não encontrado. Confira os 8 números e tente novamente.');
    if (!provinces.has(address.estado)) throw new Error('Não foi possível identificar a região desse CEP. Tente novamente.');
    if (provinceCache.size >= 10) provinceCache.delete(provinceCache.keys().next().value);
    provinceCache.set(zip, address.estado);
    return address.estado;
  };
  const resultFor = (form) => form.querySelector('[data-ps-shipping-result]');
  const reset = (form) => {
    requests.get(form)?.abort();
    requests.delete(form);
    const result = resultFor(form);
    result.replaceChildren();
    delete result.dataset.state;
    form.removeAttribute('aria-busy');
    form.querySelector('button[type="submit"]').disabled = false;
  };
  document.addEventListener('input', (event) => {
    const form = event.target.closest('[data-ps-shipping-form]');
    if (form) reset(form);
  });
  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ps-shipping-form]');
    if (!form) return;
    event.preventDefault();
    if (!form.reportValidity()) return;
    reset(form);
    const controller = new AbortController();
    requests.set(form, controller);
    const result = resultFor(form);
    const button = form.querySelector('button[type="submit"]');
    const values = new FormData(form);
    const zip = String(values.get('zip')).replace(/\D/g, '');
    const params = new URLSearchParams({
      'shipping_address[country]': 'Brazil',
      'shipping_address[zip]': zip
    });
    const root = window.Shopify.routes.root;
    const current = () => form.isConnected && requests.get(form) === controller;
    const timeout = setTimeout(() => controller.abort(), 20000);
    button.disabled = true;
    form.setAttribute('aria-busy', 'true');
    result.textContent = 'Calculando frete…';
    result.dataset.state = 'loading';
    const request = async (path, method = 'GET') => {
      const response = await fetch(`${root}cart/${path}.json?${params}`, {
        method, signal: controller.signal, headers: { Accept: 'application/json' }
      });
      const data = await response.json();
      if (!response.ok) {
        const addressError = data && !Array.isArray(data) && typeof data === 'object'
          ? Object.entries(data).filter(([key]) => ['zip', 'province', 'country'].includes(key)).flatMap(([, value]) => value).filter((value) => typeof value === 'string').join(' ')
          : '';
        throw new Error(addressError || 'Não foi possível calcular agora. Tente novamente.');
      }
      return data;
    };
    try {
      params.set('shipping_address[province]', await provinceFor(zip, controller.signal));
      if (!current()) return;
      await request('prepare_shipping_rates', 'POST');
      let data = null;
      for (let attempt = 0; attempt < 10 && data === null; attempt++) {
        if (attempt) await new Promise((resolve) => setTimeout(resolve, 1000));
        if (!current()) return;
        if (controller.signal.aborted) throw new DOMException('Timeout', 'AbortError');
        data = await request('async_shipping_rates');
      }
      if (!current()) return;
      if (data === null) throw new Error('O cálculo demorou mais que o esperado. Tente novamente.');
      const rates = data.shipping_rates;
      if (!Array.isArray(rates) || !rates.length) throw new Error('Não encontramos uma opção de entrega. Confira o CEP.');
      const list = document.createElement('ul');
      list.className = 'wt-cart-features__rates';
      const money = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: form.dataset.currency });
      for (const rate of rates) {
        const amount = Number(rate.price);
        if (!Number.isFinite(amount) || amount < 0) continue;
        const item = document.createElement('li');
        const name = String(rate.presentment_name || rate.name || 'Entrega');
        item.className = 'ps-cart-shipping-rate';
        const description = document.createElement('span');
        description.className = 'ps-cart-shipping-rate__name';
        description.textContent = name;
        const price = document.createElement('strong');
        price.className = 'ps-cart-shipping-rate__price';
        price.textContent = amount === 0 ? 'Grátis' : money.format(amount);
        const days = Array.isArray(rate.delivery_days) ? rate.delivery_days.filter((day) => Number.isFinite(day) && day >= 0) : [];
        if (days.length && !/dia/i.test(name)) {
          const min = Math.min(...days), max = Math.max(...days);
          const delivery = document.createElement('span');
          delivery.className = 'ps-cart-shipping-rate__days';
          delivery.textContent = `Prazo estimado: ${min === max ? min : `${min}–${max}`} ${min === 1 && max === 1 ? 'dia' : 'dias'}`;
          description.append(delivery);
        }
        item.append(description, price);
        list.append(item);
      }
      if (!list.children.length) throw new Error('Não foi possível calcular agora. Tente novamente.');
      const moreTemplate = form.querySelector('[data-ps-shipping-more]');
      if (list.children.length > 1 && moreTemplate?.content.firstElementChild) {
        const primary = list.cloneNode(false);
        primary.append(list.firstElementChild);
        const more = moreTemplate.content.firstElementChild.cloneNode(true);
        more.append(list);
        result.replaceChildren(primary, more);
      } else {
        result.replaceChildren(list);
      }
      result.dataset.state = 'success';
    } catch (error) {
      if (current()) {
        result.textContent = error.name === 'AbortError' ? 'O cálculo demorou mais que o esperado. Tente novamente.' : error.message;
        result.dataset.state = 'error';
      }
    } finally {
      clearTimeout(timeout);
      if (current()) {
        button.disabled = false;
        form.removeAttribute('aria-busy');
      }
    }
  });
  if (typeof subscribe === 'function') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => document.querySelectorAll('[data-ps-shipping-form]').forEach(reset));
  }
})();

(() => {
  const additionsByLook = new Map();
  let requestPending = false;
  if (!customElements.get('ps-look-products')) {
    customElements.define('ps-look-products', class extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('[data-look-add-all]');
        this.error = this.querySelector('[data-look-error]');
        if (!this.button || !this.error) return;
        this.buttonLabel = this.button.textContent;
        this.offer = this.querySelector('[data-look-offer]');
        this.fallback = this.querySelector('[data-look-cart-fallback]');
        this.syncOffer();
        if (this.offer && this.dataset.couponTimer !== 'none') {
          this.offerInterval = window.setInterval(() => this.syncOffer(), 1000);
        }
        if (!additionsByLook.has(this.dataset.lookId)) additionsByLook.set(this.dataset.lookId, new Map());
        this.additions = additionsByLook.get(this.dataset.lookId);
        this.onChange = (event) => {
          const select = event.target.closest('[data-look-variant]');
          if (!select) return;
          select.setCustomValidity('');
          select.removeAttribute('aria-invalid');
          this.showError('');
          const option = select.selectedOptions[0];
          const row = select.closest('.ps-look-product');
          if (option?.dataset.price) row.querySelector('[data-look-price]').textContent = option.dataset.price;
          const compare = row.querySelector('[data-look-compare]');
          compare.textContent = option?.dataset.compare || '';
          compare.hidden = !option?.dataset.compare;
          row.querySelector('[data-look-status]').textContent = '';
        };
        this.onSubmit = (event) => {
          const form = event.target.closest('.ps-look-product__controls');
          if (!form) return;
          event.preventDefault();
          this.addItems([form.closest('.ps-look-product')], false);
        };
        this.onAddAll = () => this.addItems([...this.querySelectorAll('.ps-look-product')], true);
        this.addEventListener('change', this.onChange);
        this.addEventListener('submit', this.onSubmit);
        this.button.addEventListener('click', this.onAddAll);
      }

      disconnectedCallback() {
        this.removeEventListener('change', this.onChange);
        this.removeEventListener('submit', this.onSubmit);
        this.button?.removeEventListener('click', this.onAddAll);
        window.clearInterval(this.offerInterval);
      }

      offerActive() {
        const code = this.dataset.couponCode?.trim();
        if (!this.offer || !code || /[,\r\n]/.test(code)) return false;
        const endsAt = this.dataset.couponEndsAt?.trim();
        if (this.dataset.couponTimer === 'deadline' && !endsAt) return false;
        if (endsAt) {
          if (!/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(?::\d{2})?(?:Z|[+-]\d{2}:\d{2})$/.test(endsAt)) return false;
          const end = Date.parse(endsAt);
          if (!Number.isFinite(end) || end <= Date.now()) return false;
        }
        return true;
      }

      syncOffer() {
        const active = this.offerActive();
        if (this.offer) this.offer.hidden = !active;
        this.buttonLabel = active ? this.dataset.couponButtonLabel : (this.dataset.addKitLabel || this.buttonLabel);
        if (!this.hasAttribute('aria-busy')) this.button.textContent = this.buttonLabel;
        const timer = this.querySelector('[data-look-timer]');
        const clock = this.querySelector('[data-look-clock]');
        if (!timer || !clock) return;
        let remaining = 0;
        if (active && this.dataset.couponTimer === 'deadline') remaining = Date.parse(this.dataset.couponEndsAt) - Date.now();
        if (active && this.dataset.couponTimer === 'loop') {
          const minutes = Number(this.dataset.couponLoopMinutes);
          if (Number.isFinite(minutes) && minutes >= 5 && minutes <= 120) {
            const cycle = minutes * 60000;
            remaining = cycle - Date.now() % cycle;
          }
        }
        timer.hidden = remaining <= 0;
        if (remaining > 0) {
          const total = Math.ceil(remaining / 1000);
          clock.textContent = [Math.floor(total / 3600), Math.floor(total / 60) % 60, total % 60]
            .map(value => String(value).padStart(2, '0')).join(':');
        }
      }

      showError(message) {
        this.error.textContent = message;
        this.error.hidden = !message;
      }

      selectedItems(rows) {
        const items = [];
        let invalidSelect;
        for (const row of rows) {
          const field = row.querySelector('[name="id"]');
          if (row.dataset.lookAvailable !== 'true' || !field || field.disabled) {
            this.showError(this.dataset.unavailableLabel);
            this.error.focus();
            return null;
          }
          const option = field.matches('select') ? field.selectedOptions[0] : null;
          if (!/^\d+$/.test(field.value) || (option && option.disabled)) {
            field.setAttribute('aria-invalid', 'true');
            field.setCustomValidity(this.dataset.requiredLabel);
            invalidSelect ||= field;
          } else {
            items.push({ row, id: field.value, quantity: 1 });
          }
        }
        if (invalidSelect) {
          this.showError(this.dataset.requiredLabel);
          invalidSelect.focus();
          invalidSelect.reportValidity();
          return null;
        }
        return items.length ? items : null;
      }

      async request(url, options = {}) {
        const controller = new AbortController();
        const timeout = window.setTimeout(() => controller.abort(), 15000);
        try {
          const response = await fetch(url, {
            credentials: 'same-origin',
            cache: 'no-store',
            ...options,
            signal: controller.signal,
            headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...options.headers }
          });
          const data = await response.json();
          if (!response.ok || data.status || data.errors) throw new Error(data.description || this.dataset.errorLabel);
          return data;
        } finally {
          window.clearTimeout(timeout);
        }
      }

      discountEntries(cart) {
        if (Array.isArray(cart.discount_codes)) return cart.discount_codes;
        const applications = [
          ...(cart.cart_level_discount_applications || []),
          ...(cart.discount_applications || []),
          ...(cart.items || []).flatMap(item => (item.line_level_discount_allocations || []).map(allocation => allocation.discount_application))
        ];
        return applications.filter(app => app?.type === 'discount_code')
          .map(app => ({ code: app.title, applicable: true }));
      }

      async applyCoupon(root, before) {
        if (!this.offerActive()) throw new Error(this.dataset.couponExpiredLabel);
        const code = this.dataset.couponCode.trim();
        const applied = cart => this.discountEntries(cart).some(entry =>
          String(entry.code).trim().toUpperCase() === code.toUpperCase() && entry.applicable === true);
        const previous = [...new Set(this.discountEntries(before).map(entry => entry.code))].join(',');
        let updated;
        try {
          updated = await this.request(root + 'cart/update.js', { method: 'POST', body: JSON.stringify({ discount: code }) });
        } catch {
          try { updated = await this.request(root + 'cart.js'); } catch {}
          if (updated && applied(updated)) return updated;
          if (updated) {
            try { await this.request(root + 'cart/update.js', { method: 'POST', body: JSON.stringify({ discount: previous }) }); } catch {}
          }
          throw new Error(this.dataset.couponErrorLabel);
        }
        if (!applied(updated)) {
          try {
            await this.request(root + 'cart/update.js', { method: 'POST', body: JSON.stringify({ discount: previous }) });
          } catch {
            throw new Error(this.dataset.couponErrorLabel);
          }
          throw new Error(this.dataset.couponInvalidLabel);
        }
        return updated;
      }

      quantities(cart) {
        const quantities = new Map();
        for (const item of cart.items || []) {
          const id = String(item.variant_id);
          quantities.set(id, (quantities.get(id) || 0) + item.quantity);
        }
        return quantities;
      }

      markAdded(items, quantities) {
        for (const item of items) {
          const target = this.additions.get(item.id);
          const added = target && (quantities.get(item.id) || 0) >= target;
          item.row.querySelector('[data-look-status]').textContent = added ? this.dataset.addedLabel : '';
        }
      }

      async addItems(rows, openCart) {
        if (requestPending) return;
        this.showError('');
        if (this.fallback) this.fallback.hidden = true;
        const activateCoupon = openCart && this.offerActive();
        const selected = this.selectedItems(rows);
        if (!selected) return;
        requestPending = true;
        this.setAttribute('aria-busy', 'true');
        const controls = [...this.querySelectorAll('button, select')].map(element => [element, element.disabled]);
        controls.forEach(([element]) => { element.disabled = true; });
        this.button.textContent = this.dataset.addingLabel;
        const root = window.Shopify?.routes?.root || '/';
        let submitted = false;
        let couponAttempted = false;
        let before;
        try {
          before = this.quantities(await this.request(root + 'cart.js'));
          const pending = selected.filter(item => {
            const target = this.additions.get(item.id);
            return !target || (before.get(item.id) || 0) < target;
          });
          let response;
          if (pending.length) {
            const cart = document.querySelector('cart-drawer');
            const sections = cart?.getSectionsToRender?.().map(section => section.id);
            for (const item of pending) this.additions.set(item.id, (before.get(item.id) || 0) + item.quantity);
            submitted = true;
            response = await this.request(root + 'cart/add.js', {
              method: 'POST',
              body: JSON.stringify({
                items: pending.map(({ id, quantity }) => ({ id, quantity })),
                ...(sections?.length ? { sections, sections_url: window.location.pathname } : {})
              })
            });
          }
          const fullCart = await this.request(root + 'cart.js');
          const after = this.quantities(fullCart);
          this.markAdded(selected, after);
          if (!selected.every(item => (after.get(item.id) || 0) >= this.additions.get(item.id))) {
            throw new Error(this.dataset.errorLabel);
          }
          if (activateCoupon) {
            couponAttempted = true;
            this.button.textContent = this.dataset.couponApplyingLabel;
            response = await this.applyCoupon(root, fullCart);
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'ps-look-products', cartData: response });
          }
          if (openCart && this.isConnected) {
            window.location.assign(this.dataset.cartUrl);
          } else if (response) {
            const cart = document.querySelector('cart-drawer');
            const sections = cart?.getSectionsToRender?.();
            if (sections?.every(section => response.sections?.[section.id])) {
              try { cart.renderContents(response, false); } catch {
                document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
              }
            } else {
              document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
            }
          }
        } catch (error) {
          if (couponAttempted) {
            if (this.fallback) this.fallback.hidden = false;
            document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
          }
          if (submitted) {
            try {
              const after = this.quantities(await this.request(root + 'cart.js'));
              this.markAdded(selected, after);
              if (selected.some(item => (after.get(item.id) || 0) > (before.get(item.id) || 0))) {
                document.dispatchEvent(new CustomEvent('cart-drawer:refresh'));
              }
            } catch {}
          }
          if (this.isConnected) this.showError(error.message || this.dataset.errorLabel);
        } finally {
          requestPending = false;
          this.removeAttribute('aria-busy');
          controls.forEach(([element, disabled]) => { element.disabled = disabled; });
          this.syncOffer();
        }
      }
    });
  }
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('.ps-shop-looks .wt-drawer-content__trigger');
    if (!trigger) return;
    const section = trigger.closest('wt-drawer-content');
    const drawer = section.drawer;
    if (!drawer || !section.isOpen) return;
    drawer.id ||= 'PsLookDrawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    section.drawerTitle.id ||= 'PsLookDrawerTitle';
    drawer.setAttribute('aria-labelledby', section.drawerTitle.id);
    trigger.setAttribute('aria-controls', drawer.id);
    section.closeBtn.setAttribute('aria-label', section.dataset.closeLabel);
    section.closeBtn.querySelector('svg')?.setAttribute('tabindex', '-1');
    section.drawerBody.scrollTop = 0;
  });
})();

